import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ServicesStyled from './ServicesSelect.styled';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { generateFilterOptions } from 'utils';

const ServicesSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  margin,
}) => {
  const [defaultValue, setDefaultValue] = useState(null);
  const services = useSelector((state) => state.auth?.organizations?.services) || [];
  const filterOptions = generateFilterOptions('start', 'label');
  const filterServices = () => {
    const data = services
      ?.filter((val) => val?.organization_type === 'SERVICE')
      .map((val) => {
        return {
          label: val.name,
          value: {
            id: val.id,
            slug: val.id_slug,
          },
        };
      });

    return data;
  };

  useEffect(() => {
    if (value || value === '') {
      const defaultVal = filterServices().find((e) => e.value.id === value.id);
      if (defaultVal) {
        setDefaultValue(defaultVal);
      } else {
        setDefaultValue(null);
      }
    }
  }, [value]) // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      id="serivice"
      value={defaultValue}
      options={filterServices()}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option.label || ''}
      getOptionSelected={(option, value) => option.value === value || defaultValue}
      onChange={(ev, val) => {
        setDefaultValue(val?.value);
        setFieldValue(name, val?.value || '');
      }}
      renderInput={(params) => (
        <ServicesStyled
          {...params}
          label={label}
          margin={margin}
          variant={variant}
          error={errors && errors[name] && touched && touched[name]}
          helperText={errors && errors[name] && touched && touched[name] && errors[name]}
        />
      )}
    />
  );
};

ServicesSelect.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  margin: PropTypes.string,
  service: PropTypes.bool,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

ServicesSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  variant: 'standard',
  label: 'Service',
  margin: 'normal',
  service: false,
};

export default ServicesSelect;
